import React, { useState, useEffect, useCallback } from "react";
import { useOutletContext } from "react-router-dom";

function Ganancias() {
  const [year, setYear] = useState("2025");
  const [semana, setSemana] = useState("");
  const [tabla, setTabla] = useState([]);
  const [titulo, setTitulo] = useState([]);
  const [fecha, setFecha] = useState("");
  const [semanas, setSemanas] = useState([]);
  const BASE_URL = useOutletContext();

  // Función para cargar los datos de la tabla
  const cargarDatos = useCallback(async () => {
    try {
      const response = await fetch(`${BASE_URL}/models.php`, {
        method: 'POST', // 👈 importante
        headers: {
          'Content-Type': 'application/json' // 👈 para que PHP lo lea como JSON
        },
        body: JSON.stringify({
          page: 'nomina',
          semana: semana
        })
      });
      const data = await response.json();

      if (Array.isArray(data)) {
        setTabla(data);
        setTitulo(["Fecha", "Aplicación", "ID", "Monedas"]);
        setFecha(semana);
      } else {
        setTabla([]);
      }
    } catch (error) {
      console.error("Error al cargar los datos:", error);
    }
  }, [semana, BASE_URL]); // ← usamos semana como dependencia porque se usa dentro

  useEffect(() => {
    if (semana !== "") {
      cargarDatos();
    }
  }, [year, semana, cargarDatos]);

  // Manejar cambio de selección de año
  const handleYearChange = (event) => {
    setYear(event.target.value);
  };

  // Manejar cambio de selección de semana
  const handleSemanaChange = (event) => {
    setSemana(event.target.value);
  };

  useEffect(() => {
    const cargarSemanas = async () => {
      try {
        const response = await fetch(`${BASE_URL}/models.php`, {
          method: 'POST', // 👈 importante
          headers: {
            'Content-Type': 'application/json' // 👈 para que PHP lo lea como JSON
          },
          body: JSON.stringify({
            page: 'ganancias',
            year: year
          })
        });
        const data = await response.json();

        // Convertimos el objeto a un array
        const semanasArray = Object.entries(data).map(([nombreSemana, rango]) => ({
          nombre: nombreSemana,
          inicio: rango.inicio,
          fin: rango.fin
        }));

        setSemanas(semanasArray);
      } catch (error) {
        console.error("Error al cargar las semanas:", error);
      }
    };

    if (year) {
      cargarSemanas();
    }
  }, [year, BASE_URL]);

  const formatearFechaDiaMes = (fechaStr) => {
    const fecha = new Date(fechaStr);
    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    return `${dia}-${mes}`;
  };

  return (
    <main>
      <h1>Documento ID Streamer</h1>
      <form onSubmit={(e) => e.preventDefault()}>
        <label htmlFor="year">Selecciona un año:</label>
        <select id="year" name="year" value={year} onChange={handleYearChange}>
          <option value="2025">2025</option>
          <option value="2024">2024</option>
        </select>
        <br></br>
        <label htmlFor="semana">Selecciona una semana:</label>
        <select id="semana" name="semana" value={semana} onChange={handleSemanaChange}>
          <option value="">--Selecciona una semana--</option>
          {semanas.map((semanaObj, index) => (
            <option key={index} value={semanaObj.fin}>
              {semanaObj.nombre}: {formatearFechaDiaMes(semanaObj.inicio)} al {formatearFechaDiaMes(semanaObj.fin)}
            </option>
          ))}
        </select>
      </form>

      {tabla.length > 0 ? (
        <center>
          <h2>Cobrando de {fecha}</h2>
          <table border="1">
            <thead>
              <tr>
                {titulo.map((title, index) => (
                  <th key={index}>{title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tabla.map((fila, index) => (
                <tr key={index}>
                  <td>{fila.Fecha}</td>
                  <td>{fila.Aplicacion}</td>
                  <td>{fila.id_streamer}</td>
                  <td>{fila.Monedas}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </center>
      ) : (
        <p>No hay cobros en este corte</p>
      )}
    </main>
  );
}

export default Ganancias;